import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=fff0bb82&scoped=true&"
import script from "./IconButton.vue?vue&type=script&lang=ts&"
export * from "./IconButton.vue?vue&type=script&lang=ts&"
import style0 from "./IconButton.vue?vue&type=style&index=0&id=fff0bb82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff0bb82",
  null
  
)

export default component.exports